import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import { useChat } from '../contexts/ChatContext'
import TchatAvatar from '../images/TchatAvatar.png'

const Message = ({ message, owner }) => {
   const { user } = useAuth()
   const { cChat } = useChat()
   const scrollRef = React.useRef()

   React.useEffect(() => {
      scrollRef.current?.scrollIntoView({ behavior: 'smooth' })

   }, [message])

   return (
      <div className={`grid ${owner ? 'grid-cols-owner' : 'grid-cols-sender'} gap-12`} ref={scrollRef}>
         <div className={`${owner ? 'col-start-2 text-center' : 'text-center'}`}>
            <img src={owner ? user.photoURL || TchatAvatar : cChat.user.photoURL || TchatAvatar} alt='avatar' className='h-16 w-16 md:h-20 md:w-20' />
            <span className='tracking-tighter text-lg md:text-xl'>Just now</span>
         </div>
         <div className={`flex flex-col gap-5 py-1 ${owner ? 'col-start-1 row-start-1 text-right self-start items-end' : 'self-start items-start'}`}>
            {
               message.text && <p className={`inline-block px-4 py-3 md:px-8 md:py-4 bg-purple-light text-white text-2xl font-light relative ${owner ? 'rounded-l-2xl rounded-br-2xl owner' : 'rounded-r-2xl rounded-bl-2xl sender'}`}>{message.text}</p>
            }
            {
               message.image && <img src={message.image} alt='file' className='h-w-52 w-52 object-cover mb-8 rounded-2xl' />
            }
         </div>
      </div>
   )
}

export default Message